<script setup>
import { useChecklist } from '@/composables/useChecklist'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'template-manage',
    subject: 'Checklist',
  },
})

const router = useRouter()
const { saving, createTemplate } = useChecklist()

const answerTypes = [
  { title: 'Ya / Tidak', value: 'yes_no' },
  { title: 'Skor', value: 'score' },
  { title: 'Teks', value: 'text' },
]

const form = ref({
  checklist_category_id: null,
  name: '',
  description: '',
  is_active: true,
  items: [{ label: '', answer_type: 'yes_no' }],
})

const errors = ref({})

const addItem = () => form.value.items.push({ label: '', answer_type: 'yes_no' })
const removeItem = index => form.value.items.splice(index, 1)

const save = async () => {
  errors.value = {}
  try {
    await createTemplate(form.value)

    router.push({ name: 'checklist-templates' })
  } catch (e) {
    if (e?.status === 422) errors.value = e?.data?.errors ?? {}
    else console.error('Create checklist template error:', e)
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Buat Template Checklist
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Item checklist hanya bisa diisi sekali saat pembuatan — tidak bisa diubah setelah template dipakai (BR-005)
    </p>

    <VCard max-width="720">
      <VCardText class="pa-6">
        <VRow>
          <VCol cols="12">
            <MasterDataPicker
              v-model="form.checklist_category_id"
              entity="checklist-categories"
              label="Kategori Checklist *"
              :error-messages="errors.checklist_category_id"
            />
          </VCol>
          <VCol cols="12">
            <VTextField
              v-model="form.name"
              label="Nama Template *"
              :error-messages="errors.name"
              autofocus
            />
          </VCol>
          <VCol cols="12">
            <VTextarea
              v-model="form.description"
              label="Deskripsi"
              rows="2"
              :error-messages="errors.description"
            />
          </VCol>
          <VCol cols="12">
            <VSwitch
              v-model="form.is_active"
              label="Aktif"
              color="success"
              hide-details
            />
          </VCol>
        </VRow>

        <VDivider class="my-4" />

        <div class="d-flex align-center justify-space-between mb-3">
          <p class="text-body-1 font-weight-medium mb-0">
            Item Checklist
          </p>
          <VBtn
            size="small"
            variant="tonal"
            prepend-icon="ri-add-line"
            @click="addItem"
          >
            Tambah Item
          </VBtn>
        </div>

        <VRow
          v-for="(item, index) in form.items"
          :key="index"
          class="align-center"
        >
          <VCol
            cols="12"
            sm="6"
          >
            <VTextField
              v-model="item.label"
              :label="`Label Item ${index + 1} *`"
              :error-messages="errors[`items.${index}.label`]"
              density="compact"
            />
          </VCol>
          <VCol
            cols="8"
            sm="4"
          >
            <VSelect
              v-model="item.answer_type"
              :items="answerTypes"
              label="Tipe Jawaban"
              density="compact"
            />
          </VCol>
          <VCol
            cols="4"
            sm="2"
          >
            <VBtn
              icon="ri-delete-bin-line"
              variant="text"
              color="error"
              :disabled="form.items.length <= 1"
              @click="removeItem(index)"
            />
          </VCol>
        </VRow>
        <p
          v-if="errors.items"
          class="text-error text-caption"
        >
          {{ errors.items[0] }}
        </p>
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          variant="tonal"
          color="secondary"
          :disabled="saving"
          @click="router.push({ name: 'checklist-templates' })"
        >
          Batal
        </VBtn>
        <VBtn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Simpan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
